import {defineStore} from 'pinia';
import {ModuleAccountCategory} from '../moduleConst';
import {BaseDictionaryStore} from '../baseDictionaryStore';
import accountCategoryAPI from '@/apis/di/accountCategoryAPI';
const accountCategoryStore = new BaseDictionaryStore(accountCategoryAPI);
export const useAccountCategoryStore = defineStore(ModuleAccountCategory, {
  state: () => ({
    ...accountCategoryStore.state,
    _config: {
      key: 'account_category_id',
      code: 'account_category_code',
      name: 'account_category_name',
      table: 'di_account_category',
      quickFollow: 'active',
      moduleName: 'Nhóm tài khoản',
      isTree: true,
      defaultSort: 'account_category_code',
    },
    moduleName: 'account_category',
  }),
  actions: {...accountCategoryStore.action},
  getters: {
    ...accountCategoryStore.getters,
  },
});
